import React, { createContext, useContext, useEffect, useState } from 'react';
import moment, { Moment } from 'moment';
const SessionContext = createContext<any>({
  isDateTimeSelected: false,
  setIsDateTimeSelected: () => {},
  startedDate:{},
  setStartedDate:() => {},
  setIsValidation: () => {},
  isValidation:false,
  setAptCreated:() => {},
  aptCreated:false,
  setActiveStep:() => {},
  activeStep:0

});

export const SessionProvider: React.FC<{ children: React.ReactNode, startDate:moment.Moment }> = ({ children,startDate }) => {
  const [isDateTimeSelected, setIsDateTimeSelected] = useState<boolean>(false);
  const [isValidation, setIsValidation] = useState<boolean>(false);
  const [startedDate, setStartedDate] = useState<moment.Moment>(startDate);
  const [aptCreated, setAptCreated] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const params={ 
    isDateTimeSelected, 
    setIsDateTimeSelected,
    startedDate,
    setStartedDate,
    setIsValidation,
    isValidation,
    setAptCreated,
    aptCreated,
    setActiveStep,
    activeStep
  }
  return (
    <SessionContext.Provider value={params}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
